/**
 * Created by tschenkel on 1/13/2015.
 */


import Event = createjs.Event;

export class SetInviteCodeEvent extends Event {
    public static INVITE_CODE_SET: string = "inviteCodeSet";
    public static SET_INVITE_CODE_FAILED: string = "setInviteCodeFailed";

    private _statusId: number;

    constructor(type: string, statusId: number, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this._statusId = statusId;
    }

    public get statusId(): number {
        return this._statusId;
    }
}

